import { render } from "./FolderList.vue?vue&type=template&id=55860e58&ts=true"
import script from "./FolderList.vue?vue&type=script&lang=ts"
export * from "./FolderList.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__